const cardsData = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20modern%20drama%20scene%2C%20a%20couple%20walking%20in%20a%20cherry%20blossom%20park%20at%20golden%20hour%2C%20soft%20warm%20lighting%2C%20cinematic%20film%20still%20aesthetic%2C%20dreamy%20atmosphere%2C%20soft%20pink%20and%20cream%20tones%2C%20editorial%20photography%2C%20romantic%20composition&width=800&height=500&seq=card-drama-01&orientation=landscape',
    tag: '国产剧',
    title: '2024年度甜宠剧王炸合辑',
    desc: '精选十部高糖分国产恋爱剧，情侣窝沙发必备片单，每一部都甜到心坎里。',
    meta: '326部 · 每日更新',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20drama%20romantic%20scene%2C%20couple%20standing%20on%20a%20rooftop%20overlooking%20Seoul%20cityscape%20at%20sunset%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20warm%20terracotta%20and%20cream%20tones%2C%20editorial%20film%20still%20aesthetic%2C%20romantic%20atmosphere&width=800&height=500&seq=card-drama-02&orientation=landscape',
    tag: '韩剧',
    title: '情侣必刷的十部经典韩剧全集',
    desc: '从《请回答》到《鬼怪》，口口相传的高分韩剧全集一次收录，和TA一起重温感动。',
    meta: '287部 · 全集中字',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20traditional%20Chinese%20hanfu%20costumes%2C%20a%20couple%20in%20flowing%20ancient%20robes%20standing%20in%20a%20bamboo%20forest%20with%20soft%20mist%2C%20golden%20sunlight%20filtering%20through%20leaves%2C%20dreamy%20atmosphere%2C%20warm%20terracotta%20and%20cream%20tones%2C%20cinematic%20film%20photography&width=800&height=500&seq=card-drama-03&orientation=landscape',
    tag: '古装剧',
    title: '古装仙侠剧全集：一眼万年',
    desc: '从仙剑到长相思，古装剧全集带你穿越千年，和另一半共赴一场东方浪漫之旅。',
    meta: '195部 · 高清修复',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20apartment%20interior%20at%20night%2C%20a%20couple%20sitting%20on%20a%20sofa%20with%20a%20laptop%20watching%20something%20together%2C%20warm%20string%20lights%20decoration%2C%20cozy%20atmosphere%2C%20soft%20ambient%20lighting%2C%20cinematic%20interior%20photography%2C%20cream%20and%20beige%20tones&width=800&height=500&seq=card-drama-04&orientation=landscape',
    tag: '新剧速递',
    title: '最新电视剧：本周热播追更日历',
    desc: '每日同步更新最新电视剧，不错过任何一部热门新剧的首播和更新，追剧快人一步。',
    meta: '142部 · 日更同步',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20crime%20drama%20scene%2C%20two%20detectives%20examining%20evidence%20in%20a%20dimly%20lit%20office%2C%20warm%20desk%20lamp%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20soft%20shadows%2C%20warm%20amber%20and%20dark%20wood%20tones%2C%20film%20still%20photography&width=800&height=500&seq=card-drama-05&orientation=landscape',
    tag: '悬疑剧场',
    title: '悬疑刑侦剧全集：一起烧脑',
    desc: '高分悬疑剧全集收录，和TA一起推理分析，边看边猜凶手，让追剧变成一场智力游戏。',
    meta: '164部 · 高能预警',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">为你精选最适合情侣一起看的电视剧专题</p>
          </div>
          <a href="#index" className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 3).map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group bg-background-50 border border-secondary-200/70 rounded-2xl overflow-hidden transition-all hover:border-primary-200/60"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.meta}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {cardsData.slice(3).map((item, idx) => (
            <a
              key={idx + 3}
              href="#cards"
              className="group flex flex-col sm:flex-row bg-background-50 border border-secondary-200/70 rounded-2xl overflow-hidden transition-all hover:border-primary-200/60"
            >
              <div className="relative w-full sm:w-[240px] h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.meta}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}